// extracted by mini-css-extract-plugin
export var hgwIconArrowDown = "Profile-module--hgwIcon-arrow-down--2wU7C";
export var hgwIconArrowUp = "Profile-module--hgwIcon-arrow-up--2_o2u";
export var profileContent = "Profile-module--profileContent--1QWL6";
export var profileContent__main = "Profile-module--profileContent__main--38esf";
export var profileItem = "Profile-module--profileItem--3pYyx";
export var animBarTypeA = "Profile-module--animBarTypeA--2SYHH";
export var animBarTypeB = "Profile-module--animBarTypeB--DBGIL";
export var animBarTypeC = "Profile-module--animBarTypeC--85S6f";
export var animBarTypeD = "Profile-module--animBarTypeD--2mi0q";